export function getDayOfWeekCode(dayName: string | null): string {
    const dayMap: Record<string, string> = {
        'Monday': 'MONDAY',
        'Tuesday': 'TUESDAY',
        'Wednesday': 'WEDNESDAY',
        'Thursday': 'THURSDAY',
        'Friday': 'FRIDAY',
        'Saturday': 'SATURDAY',
        'Sunday': 'SUNDAY',
    };

    if (!dayName) return 'UNKNOWN';

    return dayMap[dayName] || 'UNKNOWN';
}

export function getDayOfWeekName(dayOfWeek?: number | null): string {
    const dayMap: Record<number, string> = {
        0: 'Sunday',
        1: 'Monday',
        2: 'Tuesday',
        3: 'Wednesday',
        4: 'Thursday',
        5: 'Friday',
        6: 'Saturday',
    };

    if (dayOfWeek === null || dayOfWeek === undefined) {
        return 'UNKNOWN';
    }

    return dayMap[dayOfWeek] || 'UNKNOWN';
}